import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AccountRoleVM } from "@shared-kernel/application/ports/shared/shared-repository";

export const retrieveAccountRoles = createAsyncThunk<AccountRoleVM[], void, { extra: Partial<Dependencies> }>(
  "accounts/retrieveAccountRoles",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.accountRoles();
  },
);
